import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { first, shareReplay } from 'rxjs/operators';
import saveAs from 'file-saver';
import { ReportsService } from 'src/app/services/reports.service';


@Component({
  selector: 'app-challan-reconciliation-day-drill-down-report',
  templateUrl: './challan-reconciliation-day-drill-down-report.component.html',
  styleUrls: ['./challan-reconciliation-day-drill-down-report.component.scss']
})
export class ChallanReconciliationDayDrillDownReportComponent implements OnInit {

  @Input() drilldownDetails: any;
  public userId: any;
  public subjectSub: any;
  public subscriptions: any = [];
  public loading: boolean = false;
  public selectedYear: any;
  public appVerificationItems: MenuItem[];
  public drillDownData: any = [];

  constructor(
    private messageService: MessageService,
    private router: Router,
    private dashboard: DashboardService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJs: CryptoJsService,
    private service: BaseService,
    private reportsService: ReportsService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const userId = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;

    this.userId = userId;
    this.userId = encodeURIComponent(this.cryptoJs.Encrypt(this.userId))
    // console.log(this.drilldownDetails,"drilldownDetailsdrilldownDetailsdrilldownDetailsdrilldownDetails")
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        let router = this.router.url
        // this.routePath=router.split('/')
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear = res

        this.loadData(this.selectedYear)
      }

    );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.drillDownData, "Drill_down_report");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.drillDownData, "Drill_down_report");
      //   }
      // },
    ];
  }

  loadData(selectedYear: any) {
    // this.loader.start();
    this.loading = true;

    let reqBody = {
      "actionType": this.drilldownDetails.actionType,
      // "userId": this.userId,
      "status": this.drilldownDetails.status,
      "filterType": this.drilldownDetails.filterType,
      "value": this.drilldownDetails.value,
      "miType": this.drilldownDetails.MIType,
      "financialyear": selectedYear
    }

    let sub = this.reportsService.getChallanReconsillationrptDrilldown(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;

          if (data?.length > 0) {
            this.drillDownData = data;
          }
          else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

        }
      });
    this.subscriptions.push(sub);
  }


  exportExcel(modelData, filename) {

    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'AppId': d.AppID,
          'Program Name': d.Program_Name,
          'District': d.District,
          'Block': d.Block,
          'Village': d.Village,
        }
      })

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

}
